import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Simple textfield.
 * @inheritDoc
 */
export class FormModelText extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'text';

  /**
   * @inheritDoc
   * @param id
   * @param validators
   * @param unit
   * @param value
   * @param info
   * @param fieldType Type for the input field. One of text,email,number
   */
  constructor(id: string, validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true, fieldType: string = 'text') {
    super(id, validators, unit, value, info);

    this.fieldData.fieldType = fieldType;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelText {
    // @ts-ignore
    return new this.constructor(this.id, this.validators, this.unit, this.value, this.info, this.fieldData.fieldType);
  }
}
